
import { Component, Prop, Vue } from 'bits/vue'
import { WALL_ACCESS_RIGHT_COLOR_CLASS, WALL_ACCESS_RIGHT_MAP } from 'bits/wall_access_settings_helper'
import { WallAccessRight } from 'enums'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'
import BaseIcon from 'vuecomponents/base_icon.vue'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'

@Component({
  components: {
    BaseIcon,
    OzBaseButton,
  },
  mixins: [EscapeToCancelMixin],
})
class SharePermissionsSelector extends Vue {
  @Prop({ default: WallAccessRight.Read }) readonly permission!: WallAccessRight
  @Prop({ default: () => [] }) readonly options!: WallAccessRight[]
  @Prop({ required: true }) buttonLabel!: string
  isMenuVisible = false

  get menuOptions() {
    return this.options.map((permission) => ({
      ...WALL_ACCESS_RIGHT_MAP[permission],
    }))
  }

  get formalPermission() {
    return WALL_ACCESS_RIGHT_MAP[this.permission].descriptor
  }

  get permissionColorClass() {
    return WALL_ACCESS_RIGHT_COLOR_CLASS[this.permission]
  }

  open(): void {
    this.isMenuVisible = true
  }

  cancel(): void {
    this.isMenuVisible = false
  }

  selectPermission(permission) {
    this.$emit('select', permission)
  }
}
export default SharePermissionsSelector
